import { useQuery } from '@tanstack/react-query';

import { agent } from 'api/agent';
import { AlkaliProps } from 'utils/types';

export const fileKey = ['file'];

interface Props {
  type: string;
}

const useFile = ({ type }: Props) => useQuery({
  queryKey: [fileKey, type],
  queryFn: () => agent.getClient()(`file-data/calc?dataType=${type}`).then((response) => {
    const result: AlkaliProps[] = [];
    response?.data?.data?.forEach((element: any) => {
      result.push({
        ['Material A']: element?.['0'],
        ['Mol. Weight']: element?.['1'],
        ['Stoichiometry']: element?.['2'],
        ['Concentration']: element?.['3'],
        ['Formula']: element?.['4'],
      });
    });

    return result as AlkaliProps[];
  }),
});

export default useFile;
